module.exports = __webpack_public_path__ + "img/filled_block.b14f0d72.svg";